import { render, staticRenderFns } from "./TheoryAttendanceDocumentPreview.vue?vue&type=template&id=6631bdea&scoped=true"
import script from "./TheoryAttendanceDocumentPreview.vue?vue&type=script&lang=ts"
export * from "./TheoryAttendanceDocumentPreview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6631bdea",
  null
  
)

export default component.exports